import styles from './index.module.css'

export function Pokeball() {
  return <div className={styles.pokeball}></div>
}
